import React from 'react';

const ContactUs = () => {
  return <h2>Contact Us</h2>;
};

export default ContactUs;
